/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Campus_DescInputs */

const en_mk_nav_campus_desc = /** @type {(inputs: Mk_Nav_Campus_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capstone projects, lecturers, and facilitators.`)
};

const id_mk_nav_campus_desc = /** @type {(inputs: Mk_Nav_Campus_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyek capstone, dosen, dan fasilitator.`)
};

/**
* | output |
* | --- |
* | "Capstone projects, lecturers, and facilitators." |
*
* @param {Mk_Nav_Campus_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_campus_desc = /** @type {((inputs?: Mk_Nav_Campus_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Campus_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_campus_desc(inputs)
	return en_mk_nav_campus_desc(inputs)
});